import { IconPropsType } from '..';

export const AZIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14.25 16.7613L16.5417 10.9806H14.25V9.74194L18 9.74194V10.9806L15.7083 16.7613H18V18H14.25V16.7613Z" />
      <path d="M3.43634 2H5.31366L6.75 10.2581H5.45455L5.23864 8.60645H3.51136L3.29545 10.2581H2L3.43634 2ZM5.02273 7.57419L4.375 3.44516L3.72727 7.57419H5.02273Z" />
      <path d="M13.25 18H2V15.9355H13.25V18Z" />
      <path d="M6.25 2L18 2V4.06452L6.25 4.06452V2Z" />
      <path d="M13.75 13.3548H2V11.2903H13.75V13.3548Z" />
      <path d="M7.25 6.64516L18 6.64516V8.70968L7.25 8.70968V6.64516Z" />
    </svg>
  );
};
